import React, { Component } from 'react';
import {Spacer, Button, InputInline} from 'app/components/Basics/'
import { Icons } from '@ecosystem/ui-lib/core/components/Icon';
import './GlobalControlLineComponent.scss';
import { ReactComponent as SaveIcon } from 'app/assets/icons/Save.svg';
import { ReactComponent as DuplicateIcon } from 'app/assets/icons/Duplicate-Plus.svg';
import { ReactComponent as ArchiveIcon } from 'app/assets/icons/Archive.svg';
import { questionCategories } from '../../../../constants/question-categories'
import {QuestionFormContext} from '../../QuestionContext'
import ValidateQuestion, { isValidQuestionCode, getQuestionCodeValidationError, getMaxQuestionCodeLength } from '../../QuestionValidation'

class GlobalControlLine extends Component {

    constructor(props){
        super(props);

        this.state = {
            selectedQuestion: { code : "My Question!"},
            errorQuestionCode: ''        
        }        
    }

    componentWillReceiveProps(nextProps) {  
        if (nextProps && nextProps.errors && nextProps.errors !== this.props.errors) {            
            var error = nextProps.errors.find(e => e.field === "code")
            if (error) {
                this.setState({errorQuestionCode: error.errorMessage})
            }
        }
		else {
			this.setState({errorQuestionCode: ''})
		}
    }  

    getCurrentQuestionCode() {
        return this.context.selectedQuestion.code !== '' ? 
            this.context.selectedQuestion.code : "MyQuestion";
    }

    getNewQuestionCode(isEditorOpen, newQuestionCode) {
        if (!isEditorOpen && newQuestionCode) {
            var selectedQuestion = this.context.selectedQuestion;
            selectedQuestion.code = newQuestionCode;
            this.context.updateSelectedQuestion(selectedQuestion);

            if (!isValidQuestionCode(newQuestionCode)) {
                this.setState({ errorQuestionCode: getQuestionCodeValidationError() });
            } else {
                this.setState({ errorQuestionCode: '' });
            }
        }
    }

    isSaveDisabled() {
        let result = false;
        var errors = ValidateQuestion(this.context.selectedQuestion, this.props.defaultLanguageCode);
        if (errors.length > 0) {
            result = true;
        }
        if (!this.props.didSelectedQuestionChange()) {
            result = true;
        }
        return result;
    }

    isButtonDisabled(disabledForNewQuestion) {
        if (disabledForNewQuestion) {
            if (this.context.selectedQuestion.id == null) return true;
        }

        return !this.context.canChangeData || 
            (this.context.selectedQuestion.isSys === questionCategories.Demographics && !this.context.canChangeDemoQuestion);
    }

    render() {
        return (
            <div className="GlobalControlLineComponent form-row">
             {/* <input type="text" value={this.context.selectedQuestion.code} onChange={this.handleInput.bind(this)} /> */}
                <div className="name-field-wrapper">
                    <InputInline disabled={this.isButtonDisabled()} enableOnBlur className="name-field" value={this.getCurrentQuestionCode()} onModeChange={this.getNewQuestionCode.bind(this)} maxLength={getMaxQuestionCodeLength()} />
                    {this.state.errorQuestionCode && <div className="question-code-error">{this.state.errorQuestionCode}</div>}
                </div>
                <div className="contol-buttons">                    
                    <Button disabled={this.isButtonDisabled() || this.isSaveDisabled()} title="Save all changes in question" icon={<SaveIcon/>} onClick={this.props.handleSubmitAction}>Save</Button>                    
                    <Button title="Close current editor and discard all unsaved changes" onClick={this.props.closeEditorButtonOnClick} simple icon={Icons.Close}>Close</Button>
                    <Spacer width={20}/>
                   
                    <Button disabled={this.isButtonDisabled(true)} title="Delete question irreversible" small secondary icon={Icons.Delete} onClick={this.props.deleteQuestion}>Delete</Button>
                    <Button disabled={this.isButtonDisabled(true)} title="Create a new question as duplicate from this question" small secondary icon={<DuplicateIcon/>} onClick={this.props.duplicateQuestion}>Duplicate</Button>
                    <Button disabled={this.isButtonDisabled(true)} title={this.context.selectedQuestion.inArchive === 1 ? 'Move this question back from the archive' : 'Move this question into the archive'} small secondary icon={<ArchiveIcon/>} onClick={this.props.archiveQuestion}>{this.context.selectedQuestion.inArchive === 1 ? 'Unarchive' : 'Archive'} </Button>
                </div>                
            </div>  
        );
    }
}
GlobalControlLine.contextType = QuestionFormContext;
export default GlobalControlLine;